import React from 'react'
import GlobalStorage from '../storage/GlobalStorage'
import AdmZip from 'adm-zip';
import AppBlobCache from '../../AppBlobCache'
import AppZipCreator from'../../AppZipCreator'
import FileSaver from 'file-saver';
import WordImportInput from '../form/WordImportInput'
import JSONImportInput from '../form/JSONImportInput'
import AppConnector from '../../AppConnector'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter,InputGroup, Input,InputGroupAddon, Label } from 'reactstrap';
import { timingSafeEqual } from 'crypto';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';


function dataURItoBlob(dataURI) {
  // convert base64/URLEncoded data component to raw binary data held in a string
  var byteString;
  if (dataURI.split(',')[0].indexOf('base64') >= 0)
    byteString = atob(dataURI.split(',')[1]);
  else
    byteString = unescape(dataURI.split(',')[1]);
  // separate out the mime component
  var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
  // write the bytes of the string to a typed array
  var ia = new Uint8Array(byteString.length);
  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new Blob([ia], {type:mimeString});
}


export default class extends React.Component{

  constructor(props)
  {
    super(props);
    this.state = {
      file: null ,
      savedFile:null,
      src: null,
      crop: {
        unit: 'px',        
        width:1080,
        aspect: 9/16,
      },
      processing:false
    }
    this.GS = new GlobalStorage();
    this.handleChange = this.handleChange.bind(this)
    this.connector = new AppConnector;
  }

  onSelectFile = e => {
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener('load', () =>
        this.setState({ src: reader.result })
      );
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  // If you setState the crop in here you should return false.
  onImageLoaded = image => {
    this.imageRef = image;
  };

  onCropComplete = crop => {
    this.makeClientCrop(crop);
  };

  onCropChange = (crop, percentCrop) => {
    // You could also use percentCrop:
    // this.setState({ crop: percentCrop });
    this.setState({ crop });
  };

  async makeClientCrop(crop) {
    if (this.imageRef && crop.width && crop.height) {
      const croppedImageUrl = await this.getCroppedImg(
        this.imageRef,
        crop,
        'newFile.jpeg'
      );
      this.setState({ croppedImageUrl });
    }
  }

  getCroppedImg(image, crop, fileName) {
    const canvas = document.createElement('canvas');
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    canvas.width = crop.width;
    canvas.height = crop.height;
    const ctx = canvas.getContext('2d');

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height
    );

    return new Promise((resolve, reject) => {
      canvas.toBlob(blob => {
        if (!blob) {
          //reject(new Error('Canvas is empty'));
          console.error('Canvas is empty');
          return;
        }
        blob.name = fileName;
        window.URL.revokeObjectURL(this.fileUrl);
        
        const file = new File([blob], "capture.jpg", {
            type: 'image/jpg'
        });
        this.GS.getStoryEpisode().coverImage = file;

        this.fileUrl = window.URL.createObjectURL(blob);
        resolve(this.fileUrl);
      }, 'image/jpeg');
    });
  }


  handleChange(event) {
    if (event.target.files && event.target.files.length > 0 && event.target.files[0])
    {
      if (event.target.files[0].size>1024*1024)
      {
        alert("圖片上限為1MB");
      }      
      else
      {  
        this.GS.getStoryEpisode().coverImage = event.target.files[0];
        this.GS.getStoryEpisode().coverImageURL = URL.createObjectURL(event.target.files[0]);
        // console.log(this.GS.getStoryEpisode());
        this.forceUpdate();
      }
    }
  }

  _handleUpload(){
    if (this.GS.getStory().channel)
    {
      //Apply template to HTML output
      var output = `<!DOCTYPE html>
              <html>
              <head>
                <title>tbc...</title>
                <base target="_parent">
                <meta charset="UTF-8">
                <meta name="viewport" content="width=device-width, initial-scale=1">
                <link href="https://fonts.googleapis.com/css2?family=Noto+Serif+TC&display=swap" rel="stylesheet">
                <style>
                *{
                  -webkit-touch-callout: none; /* iOS Safari */
                  -webkit-user-select: none; /* Safari */
                   -khtml-user-select: none; /* Konqueror HTML */
                     -moz-user-select: none; /* Old versions of Firefox */
                      -ms-user-select: none; /* Internet Explorer/Edge */
                          user-select: none; /* Non-prefixed version, currently
                                                supported by Chrome, Edge, Opera and Firefox */
                                                font-family: \'Noto Serif TC\', serif;
                                                line-height:2;
                } 
                figcaption{
                  text-align:center;
                } 
                .instagram-media{
                  margin:0 auto !important;
                }
                p{
                  margin:0
                }
                td{
                  vertical-align:top;
                }
              
                  body.dark-mode{
                    background: #000;
                    color: #FFF;
                  }
                  body.dark-mode a{
                    color: #FFF;
                  }     
                  img{max-width:100%;height:auto !important;vertical-align: top;}    
                  iframe{max-width:100%;}
                  @media only screen and (min-width: 1080px){
                    .ac {
                      margin: 0 64px;
                    }
                  }
                  
                
                  @media only screen and (max-width: 1079.98px) and (min-width: 904px){
                    .ab {
                      margin: 0 64px;
                    }
                  }
              
                  @media only screen and (max-width: 727.98px) and (min-width: 552px){
                    .y {
                      margin: 0 24px;
                    }
                  }
                  @media only screen and (max-width: 551.98px){
                    .x {
                      margin: 0 24px;
                     }
                  }
              
                  .af {
                    min-width: 0;
                  }
                  .ae {
                    max-width: 740px;
                  }
                  .r {
                    width: 100%;
                  }
                  .w {
                      justify-content: center;
                  }
                  .v {
                      display: flex;
                      align-items: center;
                      height: 100%;
                  }    
              
                  .fix{
                    position:fixed;
                    right:10px;
                    bottom:10px;
                  }
                  .switch {
                    height: 24px;
                    display: block;
                    position: relative;
                    cursor: pointer;
                  }
                  .switch input {
                    display: none;
                  }
                  .switch input + span {
                    padding-left: 50px;
                    min-height: 24px;
                    line-height: 24px;
                    display: block;
                    color: #99A3BA;
                    position: relative;
                    vertical-align: middle;
                    white-space: nowrap;
                    -webkit-transition: color .3s ease;
                    transition: color .3s ease;
                  }
                  .switch input + span:before, .switch input + span:after {
                    content: \'\';
                    display: block;
                    position: absolute;
                    border-radius: 12px;
                  }
                  .switch input + span:before {
                    top: 0;
                    left: 0;
                    width: 42px;
                    height: 24px;
                    background: #E4ECFA;
                    -webkit-transition: all .3s ease;
                    transition: all .3s ease;
                  }
                  .switch input + span:after {
                    width: 18px;
                    height: 18px;
                    background: #fff;
                    top: 3px;
                    left: 3px;
                    box-shadow: 0 1px 3px rgba(18, 22, 33, 0.1);
                    -webkit-transition: all .45s ease;
                    transition: all .45s ease;
                  }
                  
                  .switch input + span strong {
                    font-weight: normal;
                    position: relative;
                    display: block;
                    top: 1px;
                  }
                  .switch input + span strong:before, .switch input + span strong:after {
                    font-size: 14px;
                    font-weight: 500;
                    display: block;
                    font-family: \'Mukta Malar\', Arial;
                    -webkit-backface-visibility: hidden;
                  }
                  .switch input + span strong:before {
                    content: \'Day Mode\';
                    -webkit-transition: all .3s ease .2s;
                    transition: all .3s ease .2s;
                  }
                  .switch input + span strong:after {
                    content: \'Night Mode\';
                    opacity: 0;
                    visibility: hidden;
                    position: absolute;
                    left: 0;
                    top: 0;
                    color: #FFF;
                    -webkit-transition: all .3s ease;
                    transition: all .3s ease;
                    -webkit-transform: translate(2px, 0);
                            transform: translate(2px, 0);
                  }
                  .switch input:checked + span:before {
                    background: rgba(255, 255, 255, 0.35);
                  }
                  .switch input:checked + span:after {
                    background: #fff;
                    -webkit-transform: translate(18px, 0);
                            transform: translate(18px, 0);
                  }
                  
                  .switch input:checked + span strong:before {
                    opacity: 0;
                    visibility: hidden;
                    -webkit-transition: all .3s ease;
                    transition: all .3s ease;
                    -webkit-transform: translate(-2px, 0);
                            transform: translate(-2px, 0);
                  }
                  .switch input:checked + span strong:after {
                    opacity: 1;
                    visibility: visible;
                    -webkit-transform: translate(0, 0);
                            transform: translate(0, 0);
                    -webkit-transition: all .3s ease .2s;
                    transition: all .3s ease .2s;
                  }
              
                </style>
                <script>
                function myFunction() {
                  var element = document.body;
                  element.classList.toggle("dark-mode");
                }
                </script>
              </head>
              <body  oncopy="return false" oncut="return false" onpaste="return false" ondragstart = "return false" onselectstart = "return false" oncontextmenu = "return false" onselect = "document.selection.empty()"><div class="w v"><div class="x y z ab ac ae af r">`+this.GS.getHtml()+`
              <br/><br/></div></div>
              <div class="fix">
                  <label class="switch">
                      <input type="checkbox" onclick="myFunction()">
                      <span>            
                          <strong></strong>
                      </span>
                  </label>
              </div>
              </body>
              </html>`;              
      if (this.GS.getStoryEpisode().uuid==''){
        this.setState({processing:true});
        new AppZipCreator().createChannelEpisode(output,this.GS.getStoryEpisode().project_name,()=>{
          // this.setState({processing:false});
          alert("你的故事一般會在十五分鐘後上架。");
          this.connector.listStoryEpisode(
            ()=>{
              this.props.switchMenu('Story');
              this.props.switchMain('Story');
              this.props.toggleModal(false);
            }
          );              
        },()=>{this.setState({processing:false});});
      }else{
        this.connector.updateStoryEpisode(()=>{
          this.setState({processing:true});
          new AppZipCreator().createChannelEpisode(output,this.GS.getStoryEpisode().project_name,()=>{
            // this.setState({processing:false});
            alert("你的故事一般會在十五分鐘後上架。");
            this.connector.listStoryEpisode(
              ()=>{
                this.props.switchMenu('Story');
                this.props.switchMain('Story');
                this.props.toggleModal(false);
              }
            );              
            
          },()=>{this.setState({processing:false});});
        });
      }
    }
    else
    {
      if (this.GS.getStoryEpisode().uuid==''){
        new AppZipCreator().createEpisode(()=>{
          alert("你的故事一般會在十五分鐘後上架。");
        });
      }else{
        this.connector.updateStoryEpisode(()=>{
          new AppZipCreator().createEpisode(()=>{
            alert("你的故事一般會在十五分鐘後上架。");
          });
        });
      }
    }
    
  }

  render()
  {
    const { crop, croppedImageUrl, src } = this.state;
    return (
      <div>
      <ModalHeader toggle={()=>{this.props.toggleModal()}}>章節細節</ModalHeader>
      <ModalBody>
        請輸入章節資料：
        <InputGroup>          
          <div className={"input-group-append"}>
            <span className={"input-group-text"}>章節名稱</span>
          </div>          
          <Input 
            value={this.GS.getStoryEpisode().project_name}
            onChange={(e) => {
              this.GS.getStoryEpisode().project_name = e.target.value;
              this.forceUpdate();
            }}
          />
        </InputGroup>                
        <InputGroup>          
          <div className={"input-group-append"}>
            <span className={"input-group-text"}>{(this.GS.getStory().channel)?"內容簡介":"集數"}</span>
          </div>          
          <Input 
            value={this.GS.getStoryEpisode().sequence}
            onChange={(e) => {
              this.GS.getStoryEpisode().sequence = e.target.value;
              this.forceUpdate();
            }}
          />
        </InputGroup>
        {(this.GS.getStory().channel)?
        <InputGroup className="ml-4 mt-2">                    
          
          <Input 
            id="freePreview"
            type="checkbox" 
            defaultChecked={this.GS.getStoryEpisode().freePreview}
            onChange={(e) => {
              this.GS.getStoryEpisode().freePreview = e.target.checked;
              
              this.forceUpdate();
            }}
          />
          <Label for="freePreview">試閱?</Label>         
        </InputGroup>
        :null}

        {(this.props.modalStep===2 && this.GS.getStory().channel)?(
          <div>
            <hr/>
            <div>
            請輸入發佈時間：
            <Input
            type="date"
            name="date"
            id="publishDate"
            // placeholder="date placeholder"
            onChange={(e) => {
              this.GS.getStoryEpisode().publishDate = e.target.value;              
              this.forceUpdate();
            }}
            />

            <Input
              type="time"
              name="time"
              id="publishTime"
              // placeholder="time placeholder"
              onChange={(e) => {
                this.GS.getStoryEpisode().publishTime = e.target.value;              
                this.forceUpdate();
              }}
            />
            </div>
          </div>
        ):null}

        {(this.props.modalStep===2 || this.props.modalStep===3)?(
        <div>
          
          <div>            
            <input type="file" accept="image/*" id="story-episode-cover" name="cover-image" onChange={this.onSelectFile} className={`inputfile`}/>
            <label for="story-episode-cover" class="btn-primary btn mb-0 mt-3">上載故事封面（1080 x 1920）</label>                                  
          </div>
          {src && (
            <ReactCrop
              src={src}
              crop={crop}
              ruleOfThirds
              onImageLoaded={this.onImageLoaded}
              onComplete={this.onCropComplete}
              onChange={this.onCropChange}
              minWidth={1080}
            />
          )}
          {croppedImageUrl && (
            <img alt="Crop" style={{ maxWidth: '100%' }} src={croppedImageUrl} />
          )}
        </div>):null}

{/* old coding */}
        {(0)?(
        <div>
          <InputGroup>
            <input type="file" accept="image/*" id="story-episode-cover-image" name="cover-image" onChange={this.handleChange} className={`inputfile`}/>
            <label for="story-episode-cover-image" class="btn-primary btn mb-0 mt-3">上載故事封面（1080 x 1920）</label>                      
          </InputGroup>
          圖片上限為1MB<br/>
          {(this.GS.getStoryEpisode().coverImageURL)?(
            <img style={{maxWidth:'200px'}} src={this.GS.getStoryEpisode().coverImageURL}/> 
          ):null}
          
        </div>
        ):null}
{/* end old coding */}
        
        {(this.props.modalStep===1 || this.props.modalStep===3)?(
        <div>
          <InputGroup>
            <div className={"input-group-append"}>
              <span className={"input-group-text"}>
                {(this.GS.getStory().channel==true)?`重載 Html 檔 (如有)`:`重載Word / JSON 檔 (如有)`}                
              </span>
            </div>          
            <div className={"custom-file"}>
              <input type="file" accept=".html,.json,.docx" id="savedFile" name="savedFile" class="custom-file-input" onChange={(e)=>{
                
                if (e.target.files && e.target.files.length > 0 && e.target.files[0])
                {
                  var reader = new FileReader();
                    var names = {};
                    reader.onload = ((theFile) => {
                      return (e) => {
                          this.setState({
                            savedFile: theFile.name
                          });                          
                          //console.log(this.state.savedFile);                          
                          if (theFile.type=="text/html")
                          {
                            let html = e.target.result;                            
                            new GlobalStorage().setHtml(html);

                            var old_uuid = new GlobalStorage().getStoryEpisode().uuid;                                                      
                            new GlobalStorage().getStoryEpisode().uuid = old_uuid;

                          }else if (theFile.type=="application/json")
                          {
                            //JSON
                            let lines = e.target.result;
                            console.log(lines);
                            var newArr = JSON.parse(lines);                      
                            
                            for (var i in newArr.items){                            
                              if (newArr.items[i].hasOwnProperty('bg') && newArr.items[i].bg._attributes.base64_data){
                                new AppBlobCache().putMediaBlobByKey(
                                  `/media/${newArr.items[i].bg._attributes.type}/${newArr.items[i].bg._attributes.src}.${newArr.items[i].bg._attributes.file_ext}`,
                                  {
                                    ext: newArr.items[i].bg._attributes.file_ext,
                                    filename: newArr.items[i].bg._attributes.src,
                                    type: newArr.items[i].bg._attributes.type,
                                    blob_url: window.URL.createObjectURL(dataURItoBlob(newArr.items[i].bg._attributes.base64_data)),                              
                                  });
                              }
                              if (newArr.items[i].hasOwnProperty('media') && newArr.items[i].media._attributes.base64_data){
                                new AppBlobCache().putMediaBlobByKey(
                                  `/media/${newArr.items[i].media._attributes.type}/${newArr.items[i].media._attributes.src}.${newArr.items[i].media._attributes.file_ext}`,
                                  {
                                    ext: newArr.items[i].media._attributes.file_ext,
                                    filename: newArr.items[i].media._attributes.src,
                                    type: newArr.items[i].media._attributes.type,
                                    blob_url: window.URL.createObjectURL(dataURItoBlob(newArr.items[i].media._attributes.base64_data)),                              
                                  });
                              }                          
                            }                          
                            //remove base64_data before importing for debug mode
                            //if (global.DEBUG) newArr = JSON.parse(JSON.stringify(newArr, (k,v) => (k === 'base64_data')? undefined : v));
                            var old_uuid = new GlobalStorage().getStoryEpisode().uuid;                          
                            new GlobalStorage().setStoryEpisode(newArr);                          
                            new GlobalStorage().getStoryEpisode().uuid = old_uuid;                          
                          }
                          else
                          {//Word

                            var bytes,buf ;
                            var readLen=e.target.result.byteLength;
                            var arrayBuffer = reader.result
                            bytes = new Uint8Array(arrayBuffer);
                            //console.log('insidebytes is '+bytes);
                            buf = new Buffer(e.target.result.byteLength);
                            for (var i = 0; i < buf.length; ++i) {
                              buf[i] = bytes[i];
                            }
                            //console.log(e.target.result.byteLength+' length is '+bytes.byteLength);
                            var myZip = e.target.result;   
                            //console.log('bytes is '+bytes);
                            //console.log('buf is '+buf);

                            var zip = new AdmZip(buf);                                                                                        
                            var resultList = [];
                            
                            //将document.xml(解压缩后得到的文件)读取为text内容
                            var contentXml = zip.readAsText("word/document.xml");
                            console.log(contentXml);
                            //正则匹配出对应的<w:p>里面的内容,方法是先匹配<w:p>,再匹配里面的<w:t>,将匹配到的加起来即可
                            //注意？表示非贪婪模式(尽可能少匹配字符)，否则只能匹配到一个<w:p></w:p>
                            var matchedWP = contentXml.match(/<w:p.*?>.*?<\/w:p>/gi);
                            //继续匹配每个<w:p></w:p>里面的<w:t>,这里必须判断matchedWP存在否则报错
                            if(matchedWP){
                              matchedWP.forEach(function(wpItem){
                                //detect new line and replace it with \n (\\n for json format)
                                var wpItem_w_break = wpItem.replace(new RegExp(/<w:br\/>/,'g'),"<w:t>\\n</w:t>");
                                console.log(wpItem_w_break);
                                
                                //注意这里<w:t>的匹配，有可能是<w:t xml:space="preserve">这种格式，需要特殊处理
                                var matchedWT = wpItem_w_break.match(/(<w:t>(.|\n)*?<\/w:t>)|(<w:t\s.[^>]*?>(.|\n)*?<\/w:t>)/gi);										
                                
                                
                                if(matchedWT){
                                  var textContent = '';
                                  matchedWT.forEach(function(wtItem){
                                    //如果不是<w:t xml:space="preserve">格式
                                    if(wtItem.indexOf('xml:space')===-1){
                                      textContent+=wtItem.slice(5,-6);
                                    }else{
                                      textContent+=wtItem.slice(26,-6);
                                    }
                                  });

                                  textContent = textContent.toString().replace(/"/g, '\\"');
                                  textContent = textContent.toString().replace(/&gt;/g, '>');
                                  textContent = textContent.toString().replace(/&lt"/g, '<');
                                  
                                  // var for parsing name                            
                                  var name=[''];						
                                  

                                  
                                  //extracing pargraph alignment
                                  var align_regex = /(<w:jc w:val="(.+?)")\/>/g;					
                                              
                                  if (textContent =="\\n\\n\\n"){
                                    resultList.push({
                                      text:textContent,
                                      align:"scene",
                                      name:name[0]
                                    });		

                                  }else if (wpItem.match(align_regex)){
                                    //extract right/ center if alignment tag found
                                    wpItem.replace(align_regex, function(match, matchedString, alignment) {
                                      if (alignment =='both') alignment = "left";
                                      if (alignment == "right" || alignment =="left"){
                                        //only parsing name for right and left
                                        var name_regex = /(.+?)：/g;						
                                        if (textContent.match(name_regex)){
                                          name = textContent.match(name_regex);
                                          var string = name[0];
                                          name[0] = name[0].replace("：","");
                                          textContent=textContent.replace(string,"");
                                          //console.log(string);
                                          //console.log(textContent);
                                          names[ name[0] ] = name[0];
                                        }
                                      }

                                      resultList.push({
                                        text:textContent,
                                        align:alignment,
                                        name:name[0]
                                      });							
                                    });
                                  }else{
                                    //default left

                                    //only parsing name for right and left
                                    var name_regex = /(.+?)：/g;						
                                    if (textContent.match(name_regex)){
                                      name = textContent.match(name_regex);
                                      var string = name[0];
                                      name[0] = name[0].replace("：","");
                                      textContent=textContent.replace(string,"");
                                      //console.log(string);
                                      //console.log(textContent);
                                      names[ name[0] ] = name[0];
                                    }

                                    resultList.push({
                                      text:textContent,
                                      align:"left",
                                      name:name[0]
                                    });							
                                    
                                  }												
                                }
                              });

                              var GS = new GlobalStorage();
                              var unique_names = Object.keys(names);
                              //GS.storyEpisode.characters.pop();
                              GS.clearCharacters();
                              for (const key of unique_names){
                                GS.addCharacter(key);
                              }
                                            
                              
                              var json ='{"project_name":"'+GS.getStoryEpisode().project_name+'",';
                              json +='"author":"'+GS.getStoryEpisode().author+'",';
                              json +='"email":"'+GS.getStoryEpisode().email+'",';                      

                              json+='"items":[{"title":"Scene","type":"Scene"},';

                              escape = function (str) {
                                return str
                                  .replace(/[\\]/g, '\\\\')
                                  .replace(/[\"]/g, '\\\"')
                                  .replace(/[\/]/g, '\\/')
                                  .replace(/[\b]/g, '\\b')
                                  .replace(/[\f]/g, '\\f')
                                  .replace(/[\n]/g, '\\n')
                                  .replace(/[\r]/g, '\\r')
                                  .replace(/[\t]/g, '\\t');
                              };

                                resultList.forEach(function(row){
                                  switch (row.align){
                                    case "left":
                                      json+='{"title":"Text","type":"Text","_attributes":{"style":"bubble","itemColor":"#c1cfff","position":"left"},"text":{"enabled":true,"_text":"'+escape(row.text)+'","_attributes":{"color":"#000000","size":"medium","style":"regular","anim":"line"}},"url":{"_text":""},"name":{"enabled":true,"_text":"'+row.name+'","_attributes":{"color":"#ffffff","size":"small","style":"regular"}},"bg":{"_attributes":{}},"sound":{"_attributes":{}},"overlay":{"_attributes":{},"media":{"_attributes":{}}},"isSelected":false},';
                                    break;
                                    case "center":
                                      json+='{"title":"Narrative","type":"Narrative","_attributes":{"style":"narrative","itemColor":"","position":"center","anim":"move_left"},"text":{"enabled":true,"_text":"'+escape(row.text)+'","_attributes":{"color":"#ffffff","size":"medium","style":"regular","anim":"line"}},"url":{"_text":""},"name":{"enabled":false,"_text":"","_attributes":{"color":"#ffffff","size":"small","style":"regular"}},"bg":{"_attributes":{}},"sound":{"_attributes":{}},"overlay":{"_attributes":{},"media":{"_attributes":{}}},"isSelected":false},';
                                    break;
                                    case "right":
                                      json+='{"title":"Text","type":"Text","_attributes":{"style":"bubble","itemColor":"#DDF8C6","position":"right"},"text":{"enabled":true,"_text":"'+escape(row.text)+'","_attributes":{"color":"#000000","size":"medium","style":"regular","anim":"line"}},"url":{"_text":""},"name":{"enabled":true,"_text":"'+row.name+'","_attributes":{"color":"#ffffff","size":"small","style":"regular"}},"bg":{"_attributes":{}},"sound":{"_attributes":{}},"overlay":{"_attributes":{},"media":{"_attributes":{}}},"isSelected":false},';
                                    break;		
                                    case "scene":
                                      json+='{"title":"Scene","type":"Scene"},';
                                      break;
                                  }		
                                });
                                json = json.substring(0,json.length-1);
                                json+=']}';
                                
                                var newArr = JSON.parse(json);
                                //restore new line character 
                                for ( i = 0; i < newArr.items.length; i++) {    
                                    if (newArr.items[i].text && newArr.items[i].text._text){
                                      newArr.items[i].text._text = newArr.items[i].text._text.replace(/\\n/g,"\n")                                                                       
                                      
                                    }
                                }
                                
                                GS.setStoryEpisode(newArr);
                                console.log('//WordImportInput:GlobalStorage().setStoryEpisode(newArr)');
                                
                            } 
                            
                          }
                      }
                      
                    })(e.target.files[0]);
                    if (e.target.files[0].name.includes("json") || e.target.files[0].name.includes("html"))
                      reader.readAsText(e.target.files[0]);
                    else
                      reader.readAsArrayBuffer(e.target.files[0]);  

                }

              }}/>
              <label for="savedFile" class="custom-file-label">
                {this.state.savedFile!==null?this.state.savedFile:''}
              </label>          
            </div>
            
          </InputGroup>          
        </div>        
        ):null}

      </ModalBody>
      <ModalFooter>
        {/*(this.props.modalStep===1)?(
        <div>
          <WordImportInput
          onChange={(e, filename) => {
            if (filename)
            {
              alert("已匯入" + filename + "。")              
              this.props.toggleModal();
              this.props.switchMain('StoryEpisode');
              this.props.switchMenu('StoryEpisode');
            }
          }}/>            

          <JSONImportInput
            onChange={(e, filename) => {
              if (filename)
              {
                alert("已匯入" + filename + "。")                              
                this.props.toggleModal();
                this.props.switchMain('StoryEpisode');
                this.props.switchMenu('StoryEpisode');
              }
            }}/> 
        </div>        
        ):null*/}

          {(this.props.modalStep===3)?(
          <span>
          <Button color="primary" onClick={()=>{
            
            this.connector.updateStoryEpisode(()=>{
              alert("已更新");
              this.props.toggleModal();
              this.connector.listStoryEpisode(
                ()=>{
                  this.props.switchMenu('Story');
                  this.props.switchMain('Story');
                }
              );

            });
          }}>更新章節細節</Button>{' '}       
          </span>       
        ):null}

        {(this.props.modalStep===1 || this.props.modalStep===3)?(
          <span>
          <Button color="primary" onClick={()=>{
            if (this.props.modalStep===3 && document.getElementById("savedFile").files.length==0){
              alert("請先選擇過往存檔!"); return false;
            }
            this.props.toggleModal();
            if (this.GS.getStory().channel)
              this.props.switchMain('StoryEpisodeHTML')
            else
              this.props.switchMain('StoryEpisode')
            this.props.switchMenu('StoryEpisode')
          }}>
            {(this.props.modalStep===1)?'到故事編輯器':'重載檔案到故事編輯器'}
          </Button>{' '}              
        </span>
        ):null}

        {(this.props.modalStep===2)?(
          <span>
          

      <Button color="primary" onClick={()=>{
            this.props.toggleModal();
            if (this.GS.getStory().channel)
              this.props.switchMain('StoryEpisodeHTML')
            else
              this.props.switchMain('StoryEpisode')
            this.props.switchMenu('StoryEpisode')
          }}>回到故事編輯器</Button>{' '}              
        {(!this.state.processing) ?
          <Button color="primary" onClick={()=>{                  
            if (this.GS.getUser().reader.email=='')
            {
              this.props.toggleModalState('updateProfile');
              this.props.toggleModal(true);
            }else if (this.GS.getStoryEpisode().uuid=='' && this.GS.getStoryEpisode().coverImage==null)
            {
              /*alert("請先選擇章節封面");
              this.props.toggleModalState('createEpisode',2);
              this.props.toggleModal(true);*/              

              var blob;
              switch (this.GS.getStory().category){
                case "ROMANCE":
                  blob = dataURItoBlob(global.ROMANCE);
                break;
                case "SCIENCE_FICTION":
                    blob = dataURItoBlob(global.SCIENCE_FICTION);
                break;
                case "MYSTERY":
                    blob = dataURItoBlob(global.MYSTERY);
                break;
                case "COMEDY":
                    blob = dataURItoBlob(global.COMEDY);
                break;
                case "HORROR":
                    blob = dataURItoBlob(global.HORROR);
                break;
                case "CHINESE_MARTIAL":
                    blob = dataURItoBlob(global.CHINESE_MARTIAL);
                break;
              }

              const file = new File([blob], "capture.jpg", {
                  type: 'image/jpg'
              });
              
              this.GS.getStoryEpisode().coverImage = file;

              this._handleUpload();
              

            }else
            {
              this._handleUpload();
            }
            
        }}>發佈</Button>:<Button>Loading...</Button>}

        </span>
        ):null}

        
          
      </ModalFooter>
    </div>
    )
  }
}